import { Control, FieldPath, FieldValues } from "react-hook-form";
import { FormField, FormItem } from "../base/form";
import { Select } from "../inputs/select-dropdown";
import { ComponentProps } from "react";

interface ControlledSelectProps<TFieldValues extends FieldValues>
  extends Omit<ComponentProps<typeof Select>, "name" | "onValueChange"> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  className?: string;
  onValueChange?: (value: string) => void;
}

export function ControlledSelect<TFieldValues extends FieldValues>({
  control,
  name,
  className,
  onValueChange,
  ...selectProps
}: ControlledSelectProps<TFieldValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={className}>
          <Select
            {...field}
            {...selectProps}
            onValueChange={(value) => {
              field.onChange(value);
              onValueChange?.(value);
            }}
            state={fieldState.error ? "error" : "default"}
            message={fieldState.error?.message}
          />
        </FormItem>
      )}
    />
  );
}
